import React, { memo } from 'react';
import { Handle, Position, NodeProps, Node } from '@xyflow/react';
import { KafkaTopicData } from '../types/diagram.types';

type KafkaTopicNodeType = Node<KafkaTopicData, 'kafkaTopic'>;

const KAFKA_COLOR = '#E65100';
const KAFKA_BG    = '#FFF3E0';

const KafkaTopicNode = memo(({ data, selected }: NodeProps<KafkaTopicNodeType>) => {
  return (
    <div
      style={{
        background: KAFKA_BG,
        border: selected ? `2px solid ${KAFKA_COLOR}` : `1.5px solid ${KAFKA_COLOR}88`,
        borderRadius: 6,
        padding: '4px 8px',
        minWidth: 120,
        textAlign: 'center',
        fontFamily: 'system-ui, sans-serif',
        boxShadow: selected ? `0 3px 10px ${KAFKA_COLOR}33` : '0 1px 3px rgba(0,0,0,0.08)',
        transition: 'box-shadow 0.15s, border-color 0.15s',
      }}
    >
      <div style={{
        fontSize: 10,
        fontWeight: 700,
        color: KAFKA_COLOR,
        lineHeight: 1.3,
        maxWidth: 115,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
        title={data.topicName}
      >
        {data.topicName}
      </div>
      {(data.publisherCount !== undefined || data.subscriberCount !== undefined) && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 2 }}>
          {data.publisherCount !== undefined && (
            <span style={{ fontSize: 8, color: '#BF360C', fontWeight: 600 }}>
              ↑{data.publisherCount} pub
            </span>
          )}
          {data.subscriberCount !== undefined && (
            <span style={{ fontSize: 8, color: '#1565C0', fontWeight: 600 }}>
              ↓{data.subscriberCount} sub
            </span>
          )}
        </div>
      )}

      {/* Left = receive from publishers (target) */}
      <Handle type="target" position={Position.Left}  id="left"  style={{ background: KAFKA_COLOR, border: '2px solid #fff', width: 8, height: 8 }} />
      {/* Right = send to subscribers (source) */}
      <Handle type="source" position={Position.Right} id="right" style={{ background: KAFKA_COLOR, border: '2px solid #fff', width: 8, height: 8 }} />
      {/* Top/Bottom for cross-zone routing */}
      <Handle type="target" position={Position.Top}    id="top"       style={{ background: '#90A4AE', border: '2px solid #fff', width: 6, height: 6 }} />
      <Handle type="source" position={Position.Top}    id="top-out"   style={{ background: KAFKA_COLOR, border: '2px solid #fff', width: 6, height: 6, marginLeft: 9 }} />
      <Handle type="source" position={Position.Bottom} id="bottom"    style={{ background: KAFKA_COLOR, border: '2px solid #fff', width: 6, height: 6 }} />
      <Handle type="target" position={Position.Bottom} id="bottom-in" style={{ background: '#90A4AE', border: '2px solid #fff', width: 6, height: 6, marginLeft: 9 }} />
    </div>
  );
});

KafkaTopicNode.displayName = 'KafkaTopicNode';
export default KafkaTopicNode;
